import { Project } from './valueObjects/Project';

export class ReportKey {
  constructor(
    private readonly id: number,
    private readonly operationSummary: string,
    private readonly reportId: number,
    private readonly reportName: string,
    private readonly project: Project | null
  ) {}

  getId() {
    return this.id;
  }

  getOperationSummary() {
    return this.operationSummary;
  }

  getReportId() {
    return this.reportId;
  }

  getReportName() {
    return this.reportName;
  }

  getProject() {
    return this.project;
  }
}
